import { createColumnHelper } from "@tanstack/react-table";

import StatusBadge from "~/components/StatusBadge";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import {
	getInvoiceStatusDisplayNameById,
	getInvoiceStatusThemeById,
} from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import type {
	ProjectsInvoicesTableData,
} from "~/modules/project/components/ProjectDetailsView/components/ProjectInvoicesTabContent/components/ProjectsInvoicesTable/projectsInvoicesTableTypes.ts";
import { formatNumberToCurrency } from "~/utils/currencyUtils.ts";
import { formatSmartDateRange } from "~/utils/dateAndTimeUtils.ts";
import { customArrayIncludesAll, customArrayIncludesSome } from "~/utils/tanStackTableUtils.ts";

const columnHelper = createColumnHelper<ProjectsInvoicesTableData>();
export const projectsInvoicesTableColumnDefs = [
	columnHelper.accessor("invoiceStatusId", {
		header: "Status",
		meta: {
			cellTextAlign: "center",
			width: "8rem",
		},
		cell: (props) => {
			const statusId = props.getValue();
			return <StatusBadge theme={getInvoiceStatusThemeById(statusId)}>{getInvoiceStatusDisplayNameById(statusId)}</StatusBadge>;
		},
		filterFn: customArrayIncludesSome,
	}),
	columnHelper.accessor("invoiceNumber", {
		header: "Rechnungsnummer",
		meta: {
			headerTextAlign: "left",
			cellTextAlign: "left",
			width: "12rem",
		},
		cell: (props) => props.getValue(),
	}),
	columnHelper.accessor("phaseIds", {
		header: "Phase",
		meta: {
			headerTextAlign: "center",
			cellTextAlign: "left",
			width: "10rem",
		},
		filterFn:customArrayIncludesAll,
		cell: (props) =>props.row.original.phaseTitle || EMPTY_VALUE_PLACEHOLDER
	}),
	columnHelper.accessor("orderIds", {
		header: "Bestellung",
		meta: {
			headerTextAlign: "center",
			cellTextAlign: "left",
			width: "10rem",
		},
		filterFn:customArrayIncludesAll,
		cell: (props) =>props.row.original.orderTitle || EMPTY_VALUE_PLACEHOLDER
	}),
	columnHelper.accessor("totalAmountCents", {
		header: () => <div>Rechnungsbetrag<br />(brutto)</div>,
		meta: {
			headerTextAlign: "center",
			cellTextAlign: "right",
			width: "10rem",
		},
		cell: (props) => {
			return props.getValue() ? formatNumberToCurrency(props.getValue()) + " " + props.row.original.currencySymbol : EMPTY_VALUE_PLACEHOLDER;
		},
	}),
	columnHelper.accessor("deliveryStartDate", {
		header: "Leistungszeitraum",
		meta: {
			headerTextAlign: "center",
			cellTextAlign: "center",
		},
		cell: (props) => {
			const rowData = props.row.original;
			if (!rowData.deliveryStartDate || !rowData.deliveryEndDate) return EMPTY_VALUE_PLACEHOLDER;
			return formatSmartDateRange(rowData.deliveryStartDate, rowData.deliveryEndDate, {
				month: "MMM",
				year: " yy",
			});
		},
	}),
];